module.exports = __webpack_public_path__ + "img/kiss-fresh.11d27403.png";